import { Typography } from '@mui/material';

/**
 * @typedef {Object} TextProps
 * @property {React.ReactNode} children - Text content
 * @property {string} [variant] - Typography variant (default: 'body1')
 * @property {string} [component] - HTML element to render (default: 'p')
 * @property {string} [className] - Additional CSS classes
 * @property {Object} [sx] - Additional Material-UI sx props
 * @property {string} [color] - Text color
 * @property {string} [align] - Text alignment
 * @property {boolean} [paragraph] - Whether to add paragraph spacing
 */

/**
 * Text component for consistent body text styling
 *
 * A reusable text component that provides consistent typography,
 * spacing, and styling for body text and paragraphs.
 *
 * @param {TextProps} props - Component props
 * @returns {JSX.Element} Text component
 */
function Text({
  children,
  variant = 'body1',
  component = 'p',
  className,
  sx = {},
  color = 'text.primary',
  align = 'left',
  paragraph = true,
}) {
  return (
    <Typography
      variant={variant}
      component={component}
      className={className}
      color={color}
      align={align}
      paragraph={paragraph}
      sx={{
        lineHeight: 1.6,
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}

export default Text;
